import createBrowserHistory from 'history/createBrowserHistory';

const history = createBrowserHistory();

export default {
  SetBrowserUrl(url, title) {
    if (title === '' || title === undefined) {
      title = document.title;
    }

    history.pushState(url, title, url);
  },
};
